import BehanceCircle from 'svg/behance-circle.svg';
import Clip from 'svg/clip.svg';
import Close from 'svg/close.svg';
import Clutch from 'svg/clutch.svg';
import Dribbble from 'svg/dribbble.svg';
import FacebookCircle from 'svg/facebook-circle.svg';
import FacebookRound from 'svg/facebook-round.svg';
import InfoIcon from 'svg/info-icon.svg';
import InstagramCircle from 'svg/instagram-circle.svg';
import LinkedinCircle from 'svg/linkedin-circle.svg';
import LinkedinRound from 'svg/linkedin-round.svg';
import LinkedinSquare from 'svg/linkedin-square.svg';
import LoupeLeftSide from 'svg/loupe-left-side.svg';
import Minus from 'svg/minus.svg';
import Pen2 from 'svg/pen-2.svg';
import Plus from 'svg/plus.svg';
import PlusMini from 'svg/plus-mini.svg';
import ProtectedPrivacy from 'svg/protected-privacy.svg';
import SmallArrow from 'svg/small-arrow.svg';
import TwitterRound from 'svg/twitter-round.svg';
import VideoPlayCircle from 'svg/video-play-circle.svg';
import XingCircle from 'svg/xing-circle.svg';
import CheckedCalendar from 'svg/checked-calendar.svg';
import MarkerFilled from 'svg/marker-filled.svg';

const inlineIcons = {
  'behance-circle': BehanceCircle,
  clip: Clip,
  close: Close,
  clutch: Clutch,
  dribbble: Dribbble,
  'facebook-circle': FacebookCircle,
  'facebook-round': FacebookRound,
  'info-icon': InfoIcon,
  'instagram-circle': InstagramCircle,
  'linkedin-circle': LinkedinCircle,
  'linkedin-round': LinkedinRound,
  'linkedin-square': LinkedinSquare,
  'loupe-left-side': LoupeLeftSide,
  minus: Minus,
  'pen-2': Pen2,
  plus: Plus,
  'plus-mini': PlusMini,
  'protected-privacy': ProtectedPrivacy,
  'small-arrow': SmallArrow,
  'twitter-round': TwitterRound,
  'video-play-circle': VideoPlayCircle,
  'xing-circle': XingCircle,
  'checked-calendar': CheckedCalendar,
  'marker-filled': MarkerFilled,
};

export default inlineIcons;
